import React from "react";
import RoiCalc from "../Components/RoiCalc/RoiCalc"
export default function Investing(props){
    return (<><div>
        <RoiCalc />
        </div></>);
}